import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import JoditEditor from "jodit-react";
import {
  createQuotation,
  downloadQuotationFile,
  fetchAllQuotations,
  sendQuotationToClient,
} from "../../../../store/slices/generateQuotationSlice";
import { fetchAllQuotationTemplates } from "../../../../store/slices/QuotationTemplateSlice";
import { fetchCompanyProfiles } from "../../../../store/slices/companyProfileSlice";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { fetchLeads } from "../../../../store/slices/leadsSlice";
import { fetchOtherExpenses } from "../../../../store/slices/otherexpenses";
import { getFilesByLead } from "../../../../store/slices/FileDataSlice";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import FilesViewer from "../../../lead/FilesViewer";
import FileViewer from "../../../Operations/SalesOperations/SalesFinance/CreateQuotation/FileViewer";
import CommaConvert from "../../../../utils/CommaConvert";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import configApi from "../../../../config/api";

const QuotationWizard = ({
  tasks,
  items,
  filteredQuotation,
  selectedGroup,
  selectedProject,
  setShowQuoteModal,
  tableServiceTotals: tableServiceTotalsProp,
}) => {
  console.log("filteredQuotation filteredQuotation", filteredQuotation);
  console.log("filteredQuotation filteredQuotation tasks", tasks);
  const dispatch = useDispatch();
  const USAComma = CommaConvert();
  const currency = useCurrencySymbol();
  const { enqueueSnackbar } = useSnackbar();
  const [isTemplateOpen, setIsTemplateOpen] = useState(false);
  const [isHistoryOpen, setisHistoryOpen] = useState(false);
  const [AssignedGroup, setAssignedGroup] = useState("All");
  const [template, settemplate] = useState([]);
  const { templates } = useSelector((state) => state.quotationTemplates);
  const [content, setContent] = useState(""); // Changed from value to content
  const { profiles } = useSelector((state) => state.companyProfile);
  const { leads } = useSelector((state) => state.leads);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedTemplate, setselectedTemplate] = useState("");
  const [replacedData, setReplacedData] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [Templateid, setTemplateid] = useState(null);
  const [leadid, setleadid] = useState(null);
  const [fileid, setfileid] = useState(null);
  const [sendid, setsendid] = useState(null);
  const [downloadid, setdownloadid] = useState(null);
  const { quotations } = useSelector((state) => state.generateQuotation);
  const [, sethistoryid] = useState("");
  const [files, setFiles] = useState();
  const [fileName, sefileName] = useState([]);
  const [showfile, seshowfile] = useState([]);
  const [quotation, sequotations] = useState([]);
  const { employees } = useSelector((state) => state.employees);
  const createdProject = useSelector((state) => state.wizardstep.createdProject);
  const [perdiem, setperdiem] = useState(0);
  const [averagecost, setaveragecost] = useState(0);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const [hardwareparts, sethardwareparts] = useState([]);
  const [editcontent, seteditContent] = useState(""); // Changed from value to content
  const [setMailQuotation, setsetMailQuotation] = useState(null);
  const [IsEdit, setIsEdit] = useState(false);
  const [showEditPreview, setShowEditPreview] = useState(false);
  const [editedTemplate, setEditedTemplate] = useState("");
  const [showVersionHistoryHint, setShowVersionHistoryHint] = useState(false);
  const resolvedCompanyLogoUrl = useMemo(() => {
    const profile = profiles?.[0];
    const raw = String(
      // Sidebar footer uses `logoPath`; prefer it here too for CRM consistency.
      profile?.logoPath || profile?.companylogo || profile?.companyLogo || ""
    ).trim();
    if (!raw) return "";

    let absoluteUrl = raw;
    const isAbsolute =
      /^https?:\/\//i.test(raw) || /^data:/i.test(raw) || /^blob:/i.test(raw);
    if (!isAbsolute) {
      const backendUrl = String(configApi?.backendUrl || "").trim();
      const backendOrigin = backendUrl
        .replace(/\/api\/?$/i, "")
        .replace(/\/$/, "");
      const normalizedPath = raw.replace(/^\.?\//, "");
      absoluteUrl = backendOrigin
        ? `${backendOrigin}/${normalizedPath}`
        : normalizedPath;
    }

    const stamp = profile?.updatedAt || profile?._id || "";
    if (!stamp) return absoluteUrl;
    return absoluteUrl.includes("?")
      ? `${absoluteUrl}&v=${encodeURIComponent(String(stamp))}`
      : `${absoluteUrl}?v=${encodeURIComponent(String(stamp))}`;
  }, [profiles]);

  // Get the identifier to show in Version History dropdown.
  // Prefer quotationId from the quotation itself; if not present,
  // fall back to the linked lead's quotationId. Avoid using project name.
  const getQuotationIdentifier = useCallback(
    (quot) => {
      const directId =
        quot?.quotationId ??
        quot?.QuotationId ??
        quot?.quotationNumber ??
        quot?.QuotationNumber;

      if (directId) return directId;

      // Fallback: derive from lead data
      const relatedLead = leads?.find(
        (lead) => lead?.id === quot?.leadid || lead?._id === quot?.leadid
      );

      const leadQuotationId =
        relatedLead?.quotationId ??
        relatedLead?.QuotationId ??
        relatedLead?.quotationNumber ??
        relatedLead?.QuotationNumber;

      return leadQuotationId || "—";
    },
    [leads]
  );

  console.log("filteredQuotation hardwareparts quotation", hardwareparts);
  console.log("filteredQuotation filteredQuotation employees", employees);
  console.log("filteredQuTemplateid", Templateid);

  useEffect(() => {
    if (!filteredQuotation || !employees?.length || !items?.length) return;

    const matchedItems = [];

    Object.entries(filteredQuotation).forEach(([projectName, services]) => {
      Object.entries(services).forEach(([serviceType, serviceArray]) => {
        serviceArray.forEach((service) => {
          const projectId = service.ProjectID;

          service.Assignedperson?.forEach((person) => {
            const matchedEmployee = employees.find(
              (emp) => emp.EmpEmail === person.email
            );

            if (matchedEmployee) {
              const personItems = items.filter(
                (item) =>
                  item.projectid === projectId &&
                  item.taskownerid === matchedEmployee._id
              );
              matchedItems.push(...personItems);
            }
          });
        });
      });
    });
    sethardwareparts(matchedItems);
  }, [filteredQuotation, employees, items]);

  // Jodit Editor Ref
  const editor = useRef(null);
  const imageUploadInputRef = useRef(null);
  const activeEditorForImageRef = useRef(null);

  /** Keeps caret position for async image insert (file picker / FileReader). */
  const prepareSelectionForImageInsert = useCallback((joditInstance) => {
    const j = joditInstance;
    if (!j?.selection?.save) return;
    try {
      if (j.selection.hasMarkers) {
        j.selection.restore();
      }
      j.selection.save();
    } catch {
      /* ignore */
    }
  }, []);

  const handlePickImageFromDevice = useCallback(
    (joditInstance) => {
      const j =
        joditInstance || editor.current?.editor || editor.current || null;
      activeEditorForImageRef.current = j;
      prepareSelectionForImageInsert(j);
      if (imageUploadInputRef.current) {
        imageUploadInputRef.current.value = "";
        imageUploadInputRef.current.click();
      }
    },
    [prepareSelectionForImageInsert]
  );

  const handleImageFileSelected = useCallback(
    (event) => {
      const file = event?.target?.files?.[0];
      if (!file) return;
      if (!file.type?.startsWith("image/")) {
        enqueueSnackbar("Please select a valid image file", { variant: "warning" });
        return;
      }
      const maxBytes = 8 * 1024 * 1024;
      if (file.size > maxBytes) {
        enqueueSnackbar("Image file is too large (max 8 MB). Choose a smaller file.", {
          variant: "warning",
        });
        return;
      }

      const objectUrl = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        try {
          // Template editor: small centered images (match CRM P&L-style quotation, ~200px wide).
          const maxW = 200;
          const maxH = 600;
          let w = img.naturalWidth || img.width;
          let h = img.naturalHeight || img.height;
          if (!w || !h) {
            enqueueSnackbar("Unable to read image dimensions.", { variant: "error" });
            return;
          }
          const scale = Math.min(1, maxW / w, maxH / h);
          const tw = Math.max(1, Math.round(w * scale));
          const th = Math.max(1, Math.round(h * scale));

          const canvas = document.createElement("canvas");
          canvas.width = tw;
          canvas.height = th;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            enqueueSnackbar("Unable to process image.", { variant: "error" });
            return;
          }
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, tw, th);
          ctx.drawImage(img, 0, 0, tw, th);

          const compressedSrc = canvas.toDataURL("image/jpeg", 0.82);
          const joditInstance =
            activeEditorForImageRef.current ||
            editor.current?.editor ||
            editor.current ||
            null;
          if (!joditInstance?.selection) return;

          const safeSrc = compressedSrc.replace(/"/g, "&quot;");
          const imageHtml = `<img src="${safeSrc}" alt="Uploaded Image" style="display:block;margin:0 auto;max-width:200px;width:auto;height:auto;object-fit:contain;float:none;" />`;

          try {
            joditInstance.selection.focus({ preventScroll: true });
            joditInstance.selection.restore();
          } catch {
            /* ignore */
          }
          try {
            if (joditInstance.s?.insertHTML) {
              joditInstance.s.insertHTML(imageHtml, true);
            } else if (joditInstance.selection?.insertHTML) {
              joditInstance.selection.insertHTML(imageHtml, true);
            }
          } catch {
            /* ignore */
          }
        } finally {
          URL.revokeObjectURL(objectUrl);
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        enqueueSnackbar("Unable to process selected image", { variant: "error" });
      };
      img.src = objectUrl;
    },
    [enqueueSnackbar]
  );

  // Jodit configuration
  const config = useMemo(
    () => ({
      saveSelectionOnBlur: true,
      readonly: false,
      height: 400,
      toolbarAdaptive: false,
      removeButtons: ["source", "about"],
      events: {
        // Bulletproof override: intercept the built-in image button click
        // and force system file picker (no URL dialog).
        afterInit: (jodit) => {
          try {
            const root = jodit?.container || jodit?.editor?.parentElement || null;
            const toolbarRoot =
              root?.querySelector?.(".jodit-toolbar__box") ||
              root?.querySelector?.(".jodit-toolbar") ||
              root?.querySelector?.(".jodit-toolbar-editor-collection") ||
              null;
            if (!toolbarRoot) return;

            // mousedown + capture: save selection while caret is still in the editor (click is too late).
            const onToolbarImagePointerDownCapture = (e) => {
              const t = e.target;
              if (!t || !t.closest) return;

              // Match common Jodit image button selectors across versions.
              const isImageBtn =
                t.closest('[data-name="image"]') ||
                t.closest(".jodit-toolbar-button_image") ||
                t.closest(".jodit-toolbar-button__image") ||
                t.closest('[aria-label*="image" i]') ||
                t.closest('[title*="image" i]');

              if (!isImageBtn) return;

              // Stop Jodit from opening the URL dialog.
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation?.();

              handlePickImageFromDevice(jodit);
            };

            toolbarRoot.addEventListener(
              "mousedown",
              onToolbarImagePointerDownCapture,
              true
            );
            jodit.e?.one?.("beforeDestruct", () => {
              toolbarRoot.removeEventListener(
                "mousedown",
                onToolbarImagePointerDownCapture,
                true
              );
            });

            // If the user cancels the file dialog, clear stale markers so typing stays normal.
            const editorEl = jodit.editor;
            const clearStaleImageMarkers = () => {
              try {
                if (!jodit.selection?.hasMarkers || !jodit.selection.isInsideArea) {
                  return;
                }
                jodit.selection.restore();
              } catch {
                /* ignore */
              }
            };
            if (editorEl) {
              jodit.e.on(editorEl, "mouseup", clearStaleImageMarkers);
              jodit.e.on(editorEl, "keyup", clearStaleImageMarkers);
            }
            jodit.e?.one?.("beforeDestruct", () => {
              if (editorEl) {
                jodit.e.off(editorEl, "mouseup", clearStaleImageMarkers);
                jodit.e.off(editorEl, "keyup", clearStaleImageMarkers);
              }
            });

            // If the image URL dialog still opens (varies by Jodit version),
            // strip its inputs and make the "URL" tab/caption clickable to open file picker.
            const patchImageUrlDialog = (dialogRoot) => {
              if (!dialogRoot || dialogRoot.dataset?.pskImageDialogPatched) return;

              // Heuristic: image dialog usually contains an URL input or "Alternative text"
              const hasUrlInput =
                dialogRoot.querySelector?.('input[name="url"], input[placeholder*="http" i]') ||
                dialogRoot.querySelector?.('input[name="src"]');
              const hasAlt =
                dialogRoot.querySelector?.('input[name="alt"], input[placeholder*="Alternative" i]');
              if (!hasUrlInput && !hasAlt) return;

              dialogRoot.dataset.pskImageDialogPatched = "1";

              // Hide form fields so only the clickable area remains.
              dialogRoot
                .querySelectorAll?.("input, label, textarea, .jodit-form__group, .jodit-form__fieldset")
                .forEach((el) => {
                  // Don't hide buttons (we'll handle click on URL tab)
                  const tag = (el.tagName || "").toLowerCase();
                  if (tag === "button") return;
                  el.style.display = "none";
                });

              // Find the "URL" tab/button/caption and make it clickable.
              const urlClickable =
                dialogRoot.querySelector?.('.jodit-tabs__button[role="tab"]') ||
                Array.from(dialogRoot.querySelectorAll?.("button, div, span") || []).find(
                  (el) =>
                    String(el.textContent || "").trim().toLowerCase() === "url"
                );

              if (urlClickable) {
                urlClickable.style.cursor = "pointer";
                urlClickable.style.userSelect = "none";
                urlClickable.style.pointerEvents = "auto";
                urlClickable.addEventListener(
                  "click",
                  (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation?.();
                    handlePickImageFromDevice(jodit);
                  },
                  true
                );
              }
            };

            const observer = new MutationObserver(() => {
              // Look for dialogs/popups that could be the image insert UI.
              const candidates = Array.from(
                document.querySelectorAll(".jodit-dialog, .jodit-popup, .jodit-dialog__box")
              );
              candidates.forEach((c) => patchImageUrlDialog(c));
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true,
            });

            jodit.e?.one?.("beforeDestruct", () => {
              observer.disconnect();
            });
          } catch (err) {
            // ignore
          }
        },
      },
      buttons: [
        "bold",
        "italic",
        "underline",
        "strike",
        "|",
        "ul",
        "ol",
        "|",
        "font",
        "fontsize",
        "brush",
        "|",
        "table",
        "|",
        // Keep the standard image icon, but we intercept it in `afterInit`.
        "image",
        "|",
        "align",
        "|",
        "undo",
        "redo",
        "|",
        "hr",
        "|",
        "fullsize",
      ],
      table: {
        allowCellSelection: true,
        allowResize: true,
      },
      pasteHTMLAction: "insert_clear_html", // Important for preserving HTML
    }),
    [handlePickImageFromDevice]
  );

  //   const handleAutosaveQuote = useCallback(
  //     async (content) => {
  //       const data = {
  //         _id: autosaveid,
  //         type: "AutoSave",
  //         leadid: leadid,
  //         templateid: Templateid,
  //         templatedata: content,
  //         jsondata: JSON.stringify(replacedData),
  //       };
  //       try {
  //         await dispatch(editGenerateQuotation(data));
  //       } catch (error) {
  //         console.error("Failed to create quotation template:", error);
  //         const errorMessage =
  //           error?.error ||
  //           error?.message ||
  //           "Something went wrong. Please try again.";
  //         enqueueSnackbar(errorMessage, {
  //           variant: "error",
  //           style: { zIndex: 10000 },
  //         });
  //       } finally {
  //         dispatch(fetchAllQuotations());
  //         dispatch(fetchAllQuotationTemplates());
  //       }
  //     },
  //     [Templateid, leadid, autosaveid, replacedData, enqueueSnackbar, dispatch]
  //   );

  // Handle editor change with proper debounce
  //   const handleEditorChangeWithDebounce = useCallback(
  //     (newContent) => {
  //       setContent(newContent);

  //       // Clear any existing timeout
  //       if (debounceTimeoutRef.current) {
  //         clearTimeout(debounceTimeoutRef.current);
  //       }
  //       debounceTimeoutRef.current = setTimeout(() => {
  //         handleAutosaveQuote(newContent);
  //       }, 2000); // 2000ms = 2 seconds
  //     },
  //     [handleAutosaveQuote]
  //   );

  // Cleanup timeout on unmount
  //   useEffect(() => {
  //     return () => {
  //       if (debounceTimeoutRef.current) {
  //         clearTimeout(debounceTimeoutRef.current);
  //       }
  //     };
  //   }, []);

  // Load latest auto-save - UPDATE THIS FOR JODIT
  useEffect(() => {
    if (!quotations || quotations.length === 0) return;

    // Get quotation ID from createdProject if available
    const leadQuotationId = createdProject?.[0]?.quotationId;
    const hasQuotationId = leadQuotationId != null && String(leadQuotationId).trim() !== "";

    let filteredQuotations = [];

    if (hasQuotationId) {
      // Filter by quotationId first (mandatory when available)
      filteredQuotations = quotations.filter((q) => {
        // Check if quotation has quotationId field
        if (q.quotationId != null && String(q.quotationId).trim() === String(leadQuotationId).trim()) {
          return true;
        }
        // Check if quotation's leadid matches a lead with this quotationId
        const relatedLead = leads?.find((lead) => 
          (lead.id === q.leadid || lead._id === q.leadid) &&
          lead.quotationId != null &&
          String(lead.quotationId).trim() === String(leadQuotationId).trim()
        );
        return relatedLead != null;
      });
    } else if (leadid) {
      // Fallback to leadid filtering if quotationId is not available
      filteredQuotations = quotations.filter((q) => q.leadid === leadid);
    }

    const autoSaves = filteredQuotations.filter((q) => q.type === "AutoSave");
    const sorted = autoSaves.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
    const latestAutoSave = sorted[0];
    if (latestAutoSave?.templatedata) {
      setContent(latestAutoSave.templatedata); // Use setContent instead of setValue
    }
    setTemplateid(latestAutoSave?.templateid);
  }, [quotations, leadid, createdProject, leads]);

  useEffect(() => {
    if (otherExpenses && otherExpenses.length > 0) {
      const perdiemExpense = otherExpenses.find(
        (expense) =>
          expense.description && expense.description.toLowerCase() === "perdiem"
      );

      const averageCostExpense = otherExpenses.find(
        (expense) =>
          expense.description &&
          expense.description.toLowerCase() === "average cost"
      );

      setperdiem(perdiemExpense ? perdiemExpense.cost || 0 : 0);
      setaveragecost(averageCostExpense ? averageCostExpense.cost || 0 : 0);
    } else {
      setperdiem(0);
      setaveragecost(0);
    }
  }, [otherExpenses]);

  const fetchFiles = useCallback(async () => {
    if (!fileid) {
      return;
    }
    try {
      const files = await dispatch(getFilesByLead(fileid)).unwrap();
      const pdfFiles = files.filter((file) =>
        file.filename?.toLowerCase().endsWith(".pdf")
      );
      seshowfile(pdfFiles);
      const fileNames = pdfFiles.map((file) => file.filename);
      sefileName(fileNames);
    } catch (err) {
      console.error("Error fetching files:", err);
    }
  }, [dispatch, fileid]);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  // Filter quotations by quotation ID first (from lead), then fall back to leadid
  useEffect(() => {
    if (!quotations?.length) {
      sequotations([]);
      return;
    }

    // Get quotation ID from createdProject if available
    const leadQuotationId = createdProject?.[0]?.quotationId;
    const hasQuotationId = leadQuotationId != null && String(leadQuotationId).trim() !== "";

    let filteredQuotations = [];

    if (hasQuotationId) {
      // Filter by quotationId first (mandatory when available)
      // Match quotations that have the same quotationId in their lead reference
      filteredQuotations = quotations.filter((q) => {
        // Check if quotation has quotationId field
        if (q.quotationId != null && String(q.quotationId).trim() === String(leadQuotationId).trim()) {
          return true;
        }
        // Check if quotation's leadid matches a lead with this quotationId
        const relatedLead = leads?.find((lead) => 
          (lead.id === q.leadid || lead._id === q.leadid) &&
          lead.quotationId != null &&
          String(lead.quotationId).trim() === String(leadQuotationId).trim()
        );
        return relatedLead != null;
      });
    } else if (leadid) {
      // Fallback to leadid filtering if quotationId is not available
      filteredQuotations = quotations.filter((q) => q.leadid === leadid);
    }

    sequotations(filteredQuotations);
  }, [quotations, leads, leadid, createdProject]);

  // Set lead data based on quotation ID first, then fall back to project name
  useEffect(() => {
    // Get quotation ID from createdProject if available (passed from P&L wizard)
    const leadQuotationId = createdProject?.[0]?.quotationId;
    const hasQuotationId = leadQuotationId != null && String(leadQuotationId).trim() !== "";

    let matchedLead = null;

    if (hasQuotationId && leads?.length > 0) {
      // Match by quotationId first (mandatory when available)
      matchedLead = leads.find((lead) => 
        lead.quotationId != null && String(lead.quotationId).trim() === String(leadQuotationId).trim()
      );
    }

    // Fallback to ProjectName matching if quotationId is not available or no match found
    if (!matchedLead && leads?.length > 0 && selectedProject) {
      const filteredLeads = leads.filter((lead) =>
        lead?.ProjectName?.toLowerCase()?.includes(selectedProject?.toLowerCase())
      );
      matchedLead = filteredLeads[0] || null;
    }

    if (matchedLead) {
      setfileid(matchedLead._id);
      setleadid(matchedLead.id);
      sethistoryid(matchedLead.id);
      setSelectedLead(matchedLead);
    }
  }, [leads, selectedProject, createdProject]);

  // Fetch initial data
  useEffect(() => {
    dispatch(fetchAllQuotations());
    dispatch(fetchAllQuotationTemplates());
    dispatch(fetchCompanyProfiles());
    dispatch(fetchLeads());
    dispatch(fetchAllProjects());
    dispatch(fetchOtherExpenses());
  }, [dispatch]);

  // Set templates
  useEffect(() => {
    settemplate(templates);
  }, [templates]);

  // Click outside handlers
  const groupdownRef = useRef(null);
  const handleClickOutsidegroup = (e) => {
    if (groupdownRef.current && !groupdownRef.current.contains(e.target)) {
      setIsTemplateOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidegroup);
    return () => {
      document.removeEventListener("click", handleClickOutsidegroup);
    };
  }, []);

  const versionRef = useRef(null);
  const handleClickOutsideversion = useCallback(
    (e) => {
      if (versionRef.current && !versionRef.current.contains(e.target)) {
        setisHistoryOpen(false);
      }
    },
    [versionRef]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideversion);
    return () => {
      document.removeEventListener("click", handleClickOutsideversion);
    };
  }, [handleClickOutsideversion]);

  // Replace placeholders in template - UPDATE FOR JODIT
  const replacePlaceholders = (html, lead, profile) => {
    if (!lead) return { processedHtml: html, replacedData: {} };

    const currentDate = new Date().toLocaleDateString();
    const subscriptionPackage = String(profile?.subscriptionpackage || '').trim().toUpperCase();
    const isCRMOrERP = ['CRM', 'ERP'].includes(subscriptionPackage);

    const replacedData = {
      "Project Name": lead.ProjectName || "",
      "Client Name": lead.ClientName || "",
      "Current Date": currentDate,
      "Client Contact Name": lead.ClientContactName || "",
      "Client Contact Email": lead.ClientEmail || "",
      "Company Profile Name": profile?.companyname || "",
      "Company Profile Logo": profile?.companylogo || "",
      "Company Profile Email": profile?.companyemail || "",
      "Company Profile Address": profile?.companyaddress || "",
      "File Names": fileName || "",
      templateId: Templateid,
    };

    if (isCRMOrERP) {
      replacedData["Structural Monitoring Proposal"] =
        "<div style='margin-top:16px;'>" +
        "<p style='margin:0 0 14px 0; text-align:center; font-weight:700;'>Structural Monitoring Proposal for Bridge Infrastructure</p>" +
        "<p style='margin:0 0 14px 0;'>To implement a reliable and scalable structural monitoring solution that provides continuous monitoring through high-precision accelerometers and visual inspection using intelligent camera systems.</p>" +
        "<p style='margin:0 0 10px 0; font-weight:700;'>1. Solution Overview</p>" +
        "<p style='margin:0 0 12px 0;'>Our STRUCTURAL MONITORING system integrates sensor-based vibration monitoring with visual inspection tools to provide comprehensive insights into structural performance. The system includes:</p>" +
        "<ul style='margin:0 0 14px 18px; padding-left:16px;'>" +
        "<li style='margin-bottom:6px;'><strong>Accelerometer Modules:</strong> For real-time measurement of vibrations, tilt, and dynamic structural responses.</li>" +
        "<li style='margin-bottom:6px;'><strong>Camera Modules:</strong> For periodic or event-triggered visual capture of the structure, enabling visual correlation with sensor data.</li>" +
        "<li><strong>Centralized Monitoring Interface:</strong> Displays synchronized data, alerts, and reports to the end-user.</li>" +
        "</ul>" +
        "<p style='margin:0 0 10px 0; font-weight:700;'>2. Key Features</p>" +
        "<ul style='margin:0 0 14px 18px; padding-left:16px;'>" +
        "<li style='margin-bottom:6px;'><strong>Time-Synchronized Data Acquisition:</strong> Sensor and camera data aligned to a timeframe.</li>" +
        "<li style='margin-bottom:6px;'><strong>Remote Monitoring Dashboard:</strong> Real-time access to data, event logs, and visual content.</li>" +
        "<li><strong>Threshold Alerts:</strong> Notifications triggered by abnormal vibration or tilt events.</li>" +
        "</ul>" +
        "</div>";

      replacedData["Project Background"] =
        "<div style='margin-top:20px;'>" +
        "<p style='margin:0 0 14px 0; text-align:center; font-weight:700;'>Project Background</p>" +
        "<p style='margin:0 0 12px 0;'>Webber has requested structural monitoring service for their <strong>Mid Toll Bridge, Destin Bridge and Brookes bridge</strong> located at Destin, Florida.</p>" +
        "<p style='margin:0 0 12px 0;'>To address this, <strong>Indus Informatics</strong> will implement a structural monitoring solution designed to provide real-time notifications of any structural response events using a combination of precision accelerometer and tilt sensor technologies. In the event of significant structural activity or displacement, <strong>Indus Informatics</strong> will issue automated alerts to designated WEBBER personnel via SMS, email and voice call.</p>" +
        "<p style='margin:0 0 10px 0;'>The Indus Informatics Structural Monitoring system consists of three core components:</p>" +
        "<ol style='margin:0 0 0 20px; padding-left:16px;'>" +
        "<li style='margin-bottom:6px;'><strong>Sensor Units</strong> &ndash; Capture and monitor dynamic and static structural behaviour (vibration, tilt, and temperature).</li>" +
        "<li style='margin-bottom:6px;'><strong>Communications &amp; Power Hub</strong> &ndash; Controls the system&rsquo;s operations and transmits data.</li>" +
        "<li><strong>Cloud-based Monitoring Platform</strong> &ndash; Receives and processes all incoming data for real-time analysis and alert generation.</li>" +
        "</ol>" +
        "</div>";
    }

    let processedHtml = html;

    // Replace regular placeholders
    Object.entries(replacedData).forEach(([key, value]) => {
      const regex = new RegExp(`{{${key}}}`, "g");
      processedHtml = processedHtml.replace(regex, value);
    });

    // Check for Summary Tables placeholder
    const hasSummaryTables = html.includes("{{Summary Tables}}");

    if (hasSummaryTables) {
      processedHtml = processedHtml.replace(
        /{{Summary Tables}}/g,
        "<!-- SUMMARY_TABLES -->"
      );
    }

    // Clean up any leftover placeholders
    processedHtml = processedHtml.replace(/{{[^}]+}}/g, "");

    if (isCRMOrERP) {
      let formatted = processedHtml;
      const logoUrl =
        resolvedCompanyLogoUrl ||
        profile?.companylogo ||
        profile?.logoPath ||
        profile?.companyLogo ||
        "";
      const crmHeaderEmail = "info@indusinformatics.com";
      const crmHeaderMarker = "<!-- CRM_QUOTATION_HEADER -->";

      const crmHeaderHtml = `
${crmHeaderMarker}
<div style="width:100%; display:flex; align-items:flex-start; justify-content:space-between; margin-top:6px;">
  <div style="flex:0 0 45%; display:flex; align-items:center;">
    <img src="${String(logoUrl).replace(/"/g, "&quot;")}" alt="Company Logo" style="max-height:60px; object-fit:contain;" />
  </div>
  <div style="flex:0 0 auto; width:1px; background:#000; height:60px; margin:0 14px;"></div>
  <div style="flex:1; text-align:right; font-size:12px; line-height:1.4; padding-top:10px;">
    <div><strong>Email:</strong> ${crmHeaderEmail}</div>
    <div><strong>Address:</strong> 4830, Osage Avenue,<br/>Philadelphia, PA 19143</div>
  </div>
</div>
<div style="margin-top:10px; border-top:2px solid #000;"></div>
`;

      const dateParaRegex = /<p>\s*Date:\s*([^<]+)\s*<\/p>/i;
      const dateMatch = formatted.match(dateParaRegex);
      if (dateMatch) {
        const dt = String(dateMatch[1] || "").trim();
        formatted = formatted.replace(dateParaRegex, "");
        formatted = `<p style="text-align:right; margin:0 0 10px 0;">Date: ${dt}</p>${formatted}`;
      } else {
        const dateTextRegex = /Date:\s*([^<\n\r]+)/i;
        const dateTextMatch = formatted.match(dateTextRegex);
        if (dateTextMatch) {
          const dt = String(dateTextMatch[1] || "").trim();
          formatted = formatted.replace(dateTextRegex, "");
          formatted = `<p style="text-align:right; margin:0 0 10px 0;">Date: ${dt}</p>${formatted}`;
        }
      }

      formatted = formatted.replace(
        /<p>\s*To,\s*"([^"]+)"\s*<\/p>/gi,
        (_m, clientName) => `<p>To,</p><p>${String(clientName || "").trim()}</p>`
      );
      formatted = formatted.replace(
        /To,\s*"([^"]+)"\s*/gi,
        (_m, clientName) => `To,<br/>${String(clientName || "").trim()}`
      );
      formatted = formatted.replace(
        /<p>\s*Dear\s*"([^"]+)"\s*,\s*<\/p>/gi,
        (_m, clientName) => `<p>Dear ${String(clientName || "").trim()},</p>`
      );
      formatted = formatted.replace(
        /Dear\s*"([^"]+)"\s*,/gi,
        (_m, clientName) => `Dear ${String(clientName || "").trim()},`
      );

      if (!formatted.includes(crmHeaderMarker) && !formatted.includes(crmHeaderEmail)) {
        processedHtml = crmHeaderHtml + formatted;
      } else {
        processedHtml = formatted;
      }
    }

    return { processedHtml, replacedData };
  };

  // Load template - UPDATE FOR JODIT
  const loadTemplate = async (tplUrl) => {
    try {
      const res = await fetch(tplUrl);
      if (!res.ok) throw new Error("Failed to fetch template");

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      let templateContent = doc.body.innerHTML;

      const profile = profiles.length > 0 ? profiles[0] : null;
      const { processedHtml, replacedData } = replacePlaceholders(
        templateContent,
        selectedLead,
        profile
      );

      // Now insert the dynamic HTML content where placeholders were
      let finalHtml = processedHtml;

      // Replace SUMMARY_TABLES placeholder if it exists and we have the HTML
      if (
        processedHtml.includes("<!-- SUMMARY_TABLES -->") &&
        serviceTableHTML
      ) {
        finalHtml = finalHtml.replace(
          "<!-- SUMMARY_TABLES -->",
          serviceTableHTML
        );
      }

      setContent(finalHtml); // Use setContent instead of setValue
      setReplacedData(replacedData);
    } catch (error) {
      console.error("Error loading template:", error);
      if (enqueueSnackbar) {
        enqueueSnackbar("Failed to load template", { variant: "error" });
      }
    }
  };

  // Format date
  //   const formatDate = (dateString) => {
  //     const date = new Date(dateString);
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const day = String(date.getDate()).padStart(2, "0");
  //     const year = date.getFullYear();
  //     return `${month}-${day}-${year}`;
  //   };

  const cleanNumericValues = (htmlContent) => {
    return htmlContent;
    // return htmlContent.replace(
    //   />\s*([\d,]+)\s*</g,
    //   (match, numberWithCommas) => {
    //     const cleanNumber = numberWithCommas.replace(/,/g, "");
    //     return `>${cleanNumber}<`;
    //   }
    // );
  };

  const normalizeHardwareDetailsForGeneratedQuote = useCallback(
    (htmlContent) => {
      if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");
        const headingNodes = Array.from(doc.querySelectorAll("p"));

        headingNodes.forEach((pEl) => {
          const title = (pEl.textContent || "").trim().toLowerCase();
          if (title !== "hardware details") return;

          const sectionWrapper = pEl.parentElement;
          if (!sectionWrapper) return;

          const tableEl = sectionWrapper.querySelector("table");
          if (tableEl) {
            const rows = Array.from(tableEl.querySelectorAll("tbody tr"));
            rows.forEach((tr) => {
              const partInput = tr.querySelector(
                'input[name^="hardwarePartName_"]'
              );
              const qtyInput = tr.querySelector(
                'input[name^="hardwarePartQty_"]'
              );
              if (!partInput && !qtyInput) return;

              const partVal = String(
                partInput?.getAttribute("value") ?? partInput?.value ?? ""
              ).trim();
              const qtyVal = String(
                qtyInput?.getAttribute("value") ?? qtyInput?.value ?? ""
              ).trim();

              if (partInput) {
                partInput.parentElement.innerHTML = partVal || "&nbsp;";
              }
              if (qtyInput) {
                qtyInput.parentElement.innerHTML = qtyVal || "&nbsp;";
              }
            });
          }

          // Remove add/remove row controls in generated quotation output.
          const actionButtons = Array.from(
            sectionWrapper.querySelectorAll("button")
          );
          actionButtons.forEach((btn) => btn.remove());
        });

        return doc.body.innerHTML;
      } catch (e) {
        console.warn("Failed to normalize hardware details table:", e);
        return htmlContent;
      }
    },
    []
  );

  const normalizeImageSourcesForGeneratedQuote = useCallback((htmlContent) => {
    if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const backendUrl = String(configApi?.backendUrl || "").trim();
      const backendOrigin = backendUrl.replace(/\/api\/?$/i, "").replace(/\/$/, "");

      const imgNodes = Array.from(doc.querySelectorAll("img[src]"));
      imgNodes.forEach((img) => {
        const rawSrc = String(img.getAttribute("src") || "").trim();
        if (!rawSrc) return;
        const isAbsolute =
          /^https?:\/\//i.test(rawSrc) ||
          /^data:/i.test(rawSrc) ||
          /^blob:/i.test(rawSrc);
        if (!isAbsolute) {
          const normalizedPath = rawSrc.replace(/^\.?\//, "");
          const absoluteSrc = backendOrigin
            ? `${backendOrigin}/${normalizedPath}`
            : normalizedPath;
          img.setAttribute("src", absoluteSrc);
        }
      });

      return doc.body.innerHTML;
    } catch (e) {
      console.warn("Failed to normalize image sources:", e);
      return htmlContent;
    }
  }, []);

  const handleGenerate = async (contentOverride) => {
    if (!Templateid) {
      enqueueSnackbar("Please select template first", {
        variant: "error",
      });
      return;
    }

    const subscriptionPackage = String(
      profiles?.[0]?.subscriptionpackage || ""
    )
      .trim()
      .toUpperCase();
    const isCRM = subscriptionPackage === "CRM";
    const isERP = subscriptionPackage === "ERP";
    const isCRMOrERP = isCRM || isERP;

    // Clean the content before sending
    const hasOverride = typeof contentOverride === "string" && contentOverride.length > 0;
    let finalContent = hasOverride ? contentOverride : content;

    // Preview mode: editor refs/DOM may not exist. When we have an override, do NOT touch editorInstance.value.
    if (isCRMOrERP && !hasOverride) {
      const editorInstance = editor.current?.editor || editor.current;
      const liveEditorHtml =
        (typeof editorInstance?.value === "string" && editorInstance.value) ||
        (typeof editorInstance?.getEditorValue === "function" &&
          editorInstance.getEditorValue()) ||
        "";
      if (liveEditorHtml) {
        finalContent = liveEditorHtml;
      }

      if (isCRM) {
        // CRM: Jodit commonly renders inside an iframe; patch typed <input> values into value="..." attributes
        // so backend receives the user's entered data.
        try {
          let editorDoc = null;
          const iframeCandidates = [];
          if (editorInstance?.iframe)
            iframeCandidates.push(editorInstance.iframe);

          const rootEl =
            editorInstance?.container ||
            editorInstance?.element ||
            editorInstance?.el ||
            editor.current;
          if (rootEl?.querySelectorAll) {
            iframeCandidates.push(
              ...Array.from(rootEl.querySelectorAll("iframe"))
            );
          }

          for (const iframeEl of iframeCandidates) {
            const d =
              iframeEl?.contentDocument ||
              iframeEl?.contentWindow?.document ||
              null;
            if (d && d.querySelectorAll) {
              editorDoc = d;
              break;
            }
          }

          if (!editorDoc) {
            editorDoc =
              editorInstance?.ownerDocument ||
              editor.current?.ownerDocument ||
              document;
          }

          const priceInputs = editorDoc?.querySelectorAll
            ? editorDoc.querySelectorAll(
                'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
              )
            : [];

          if (priceInputs && priceInputs.length > 0) {
            priceInputs.forEach((inputEl) => {
              const nameAttr = inputEl.getAttribute("name") || "";
              if (!nameAttr) return;

              const safeName = nameAttr.replace(
                /[.*+?^${}()|[\]\\]/g,
                "\\$&"
              );

              const rawVal = inputEl.value ?? "";
              const escapedVal = String(rawVal)
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;");

              // Update only the value="..." attribute for robustness.
              const valueAttrRegex = new RegExp(
                `(<input[^>]*name="${safeName}"[^>]*value=")[^"]*(")`,
                "g"
              );

              const before = finalContent;
              finalContent = finalContent.replace(
                valueAttrRegex,
                (m, p1, p2) => `${p1}${escapedVal}${p2}`
              );

              // Fallback: replace entire input tag if value attr not found.
              if (finalContent === before) {
                const outer = inputEl.outerHTML;
                const inputTagRegex = new RegExp(
                  `<input[^>]*name="${safeName}"[^>]*>`,
                  "g"
                );
                finalContent = finalContent.replace(inputTagRegex, outer);
              }
            });
          }
        } catch (e) {
          console.warn("Failed to patch CRM service prices:", e);
        }

        finalContent =
          normalizeHardwareDetailsForGeneratedQuote(finalContent);
      }
    }

    finalContent = normalizeImageSourcesForGeneratedQuote(finalContent);
    const cleanedContent = cleanNumericValues(finalContent);
    console.log("generatedQuotation cleanedContent", cleanedContent);
    const data = {
      type: "GeneratedQuote",
      leadid: leadid,
      templateid: Templateid,
      templatedata: cleanedContent, // Use cleaned content
      jsondata: JSON.stringify(replacedData),
    };
    console.log("handleGenerate data wiz", data);
    SetisLoading(true);
    try {
      await dispatch(createQuotation(data)).unwrap();
      setShowVersionHistoryHint(true);
      enqueueSnackbar("Quotation Created Successfully", {
        variant: "success",
        style: { zIndex: 10000 },
      });
    } catch (error) {
      console.error("Failed to create quotation template:", error);
      const errorMessage =
        error?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
        style: { zIndex: 10000 },
      });
    } finally {
      SetisLoading(false);
      setIsEdit(false);
      setShowEditPreview(false);
      dispatch(fetchAllQuotations());
      dispatch(fetchAllQuotationTemplates());
    }
  };

  const handleedit = () => {
    setsendid(null);
    setContent(editcontent);
    setEditedTemplate(editcontent || "");
    setIsEdit(true);
    setShowEditPreview(false);
  };

  // Save after edit: show preview window (do NOT generate yet)
  const handleSaveEdit = () => {
    setEditedTemplate(content || "");
    setShowEditPreview(true);
  };

  // Generate from edit preview: create new quotation version with edited content
  const handleGenerateFromPreview = async () => {
    const snapshot = editedTemplate || "";
    if (!snapshot) {
      console.error("No content available for generation");
      enqueueSnackbar("No edited content to generate. Please edit and Save first.", {
        variant: "error",
        style: { zIndex: 10000 },
      });
      return;
    }

    const payload = {
      quotationId: createdProject?.[0]?.quotationId ?? selectedLead?.quotationId,
      leadId: leadid,
      templateId: Templateid,
      content: snapshot,
    };
    console.log("Generate Payload:", payload);

    await handleGenerate(snapshot);
    setShowEditPreview(false);
    setIsEdit(false);
  };
  // Handle download quotation
  const handleDownload = async () => {
    if (!downloadid) {
      enqueueSnackbar("Please select template before download", {
        variant: "error",
        style: { zIndex: 10000 },
      });
      return;
    }

    SetisLoading(true);
    try {
      const response = await dispatch(downloadQuotationFile(downloadid));
      const resData = response?.payload;

      if (!resData?.downloadUrl) {
        throw new Error("Download failed");
      }

      const link = document.createElement("a");
      link.href = resData.downloadUrl;

      const extension = resData.contentType?.includes("pdf") ? "pdf" : "file";

      link.setAttribute("download", `quotation.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      enqueueSnackbar("Quotation File Successfully Downloaded", {
        variant: "success",
        style: { zIndex: 10000 },
      });
    } catch (error) {
      enqueueSnackbar(
        error?.message || "Something went wrong. Please try again.",
        {
          variant: "error",
          style: { zIndex: 10000 },
        }
      );
    } finally {
      SetisLoading(false);
      setdownloadid(null);
    }
  };

  // Handle send quotation - UPDATE FOR JODIT
  const handleSend = async () => {
    if (!sendid) {
      enqueueSnackbar("Please select template first", {
        variant: "error",
      });
      return;
    }

    SetisLoading(true);
    try {
      await dispatch(
        sendQuotationToClient({
          quotationId: setMailQuotation?._id,
        })
      );
      enqueueSnackbar("The quotation file has been sent successfully", {
        variant: "success",
        style: { zIndex: 10000 },
      });
    } catch (error) {
      console.error("Failed to create quotation template:", error);
      const errorMessage =
        error?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
        style: { zIndex: 10000 },
      });
    } finally {
      SetisLoading(false);
      setContent(""); // Use setContent instead of setValue
    }
  };

  const getDescriptionValues = useCallback(
    (projectID, personID, typeService) => {
      if (!tasks) return [];
      return tasks.filter(
        (desc) => desc.projectid === projectID && desc.taskownerid === personID
      );
    },
    [tasks]
  );

  const getTotalDescriptionValue = useCallback(
    (projectID, personID, typeService) => {
      const descriptions = getDescriptionValues(
        projectID,
        personID,
        typeService
      );

      let totalValue = descriptions.reduce(
        (sum, desc) => sum + (desc.value || 0),
        0
      );

      if (typeService && typeService.toLowerCase().includes("installation")) {
        let maxTripDuration = 0;
        const uniqueTripDurations = new Set();

        descriptions.forEach((desc) => {
          if (desc.tripduration) {
            uniqueTripDurations.add(desc.tripduration);
            maxTripDuration = Math.max(maxTripDuration, desc.tripduration);
          }
        });

        if (maxTripDuration > 0) {
          // Add: (tripduration * perdiem) + (tripduration * averageCost)
          totalValue +=
            maxTripDuration * perdiem + maxTripDuration * averagecost;
        }
      }

      return totalValue;
    },
    [getDescriptionValues, perdiem, averagecost]
  );

  const getHardwareValues = useCallback(
    (projectID, typeService) => {
      if (!items) return [];
      return items.filter(
        (desc) =>
          desc.projectid === projectID &&
          // desc.taskownerid === personID &&
          desc.typeservice === typeService
      );
    },
    [items]
  );

  const getTotalHardwareCostValue = useCallback(
    (projectID, personID, typeService) => {
      let hardwareValue = 0;
      const hardwareCost = getHardwareValues(projectID, typeService);
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      hardwareCost.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
      return hardwareValue;
      // return hardwareCost.reduce((sum, desc) => sum + (desc.totalprice || 0), 0);
    },
    [getHardwareValues]
  );

  const transformFilteredQuotation = useCallback(
    (filteredQuotation, employees) => {
      const result = [];

      Object.entries(filteredQuotation || {}).forEach(
        ([projectName, typeServices]) => {
          Object.entries(typeServices).forEach(([typeService, items]) => {
            items.forEach((item) => {
              if (!item?.WorkEntries?.length) return;

              // Group work entries by person
              const groupedByPerson = {};
              const personRoleMap = {};

              item.WorkEntries.forEach((entry) => {
                const personName = entry?.createdBy?.name;
                const personRoles = entry?.createdBy?.role || [];
                const personId = entry?.taskownerid;

                if (!groupedByPerson[personName]) {
                  groupedByPerson[personName] = { totalHours: 0, personId };
                }
                groupedByPerson[personName].totalHours +=
                  entry.hoursassigned || 0;

                if (!personRoleMap[personName]) {
                  personRoleMap[personName] = { roles: personRoles, personId };
                }
              });

              // Convert grouped persons into array with costs
              Object.entries(groupedByPerson).forEach(([name, personData]) => {
                const totalHours = personData.totalHours;
                const personId = personData.personId;
                const ProjectID = item?.ProjectID;
                const ProjectNotes = item?.ProjectNotes;
                const ServiceQuotedValue = item?.QuotedValue;
                const servicewiseMargin = item?.ProjectMargin;

                // CRITICAL FIX: Match quotation by personid and taskownerid
                const matchedQuotation = item?.quotationDetails?.find(
                  (q) => q.personid === personId
                );

                const currentEmployee = employees.find((emp) => {
                  const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`
                    .trim()
                    .toLowerCase();
                  return fullName === name.trim().toLowerCase();
                });

                const capitalizedRoles =
                  currentEmployee?.customRoles?.map(
                    (role) =>
                      role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
                  ) || [];

                const hourlyRate =
                  (matchedQuotation?.hourlysalaray || 0) +
                  (matchedQuotation?.overheadpercentage || 0);

                const totalCost = totalHours * hourlyRate;

                const descriptionTotal = getTotalDescriptionValue(
                  item.ProjectID,
                  personId,
                  item.TypeService
                );

                const hardwareTotal = getTotalHardwareCostValue(
                  item.ProjectID,
                  personId,
                  item.TypeService
                );

                const hasProjectManagerRole =
                  capitalizedRoles.includes("Project manager");
                result.push({
                  servicewiseMargin,
                  ServiceQuotedValue,
                  projectName,
                  typeService: item.TypeService,
                  resourceType: item.ResourceType,
                  personId,
                  ProjectID,
                  ProjectNotes,
                  personName: name,
                  roles: capitalizedRoles,
                  totalHours,
                  hourlyRate,
                  totalCost,
                  descriptionTotal,
                  hardwareTotal,
                  grandTotal: item?.TypeService?.toLowerCase().includes(
                    "hardware"
                  )
                    ? (hasProjectManagerRole ? hardwareTotal : 0) +
                    descriptionTotal
                    : descriptionTotal + totalCost,
                });
              });
            });
          });
        }
      );

      return result;
    },
    [getTotalDescriptionValue, getTotalHardwareCostValue]
  );

  const groupByTypeService = (processedData) => {
    return processedData.reduce((acc, curr) => {
      if (!acc[curr.typeService]) {
        acc[curr.typeService] = [];
      }
      acc[curr.typeService].push(curr);
      return acc;
    }, {});
  };

  const processedData = useMemo(() => {
    return transformFilteredQuotation(filteredQuotation, employees);
  }, [filteredQuotation, employees, transformFilteredQuotation]);

  const groupedData = useMemo(() => {
    return groupByTypeService(processedData);
  }, [processedData]);

  const generateServiceTableHTML = useCallback(
    (groupedData) => {
      const isCRM = profiles?.[0]?.subscriptionpackage === "CRM";

      // CRM: editable "Finance Summary" (servicePrice_*) + optional Hardware Details (hardwarePartName_/hardwarePartQty_*)
      if (isCRM && selectedLead) {
        const cellStyle =
          "border: 1px solid #000; padding: 8px; min-width: 80px; min-height: 32px;";

        let tableHtml = "";

        const serviceTypesArrCandidate =
          selectedLead?.servicetypes ??
          selectedLead?.serviceTypes ??
          selectedLead?.ServiceTypes ??
          selectedLead?.TypeService ??
          [];

        const serviceTypes = (() => {
          const toTypeName = (st) => {
            if (!st) return "";
            if (typeof st === "string") return st;
            return (
              st.TypeService ||
              st.typeService ||
              st.ServiceType ||
              st.serviceType ||
              st.type ||
              ""
            );
          };

          if (Array.isArray(serviceTypesArrCandidate)) {
            return serviceTypesArrCandidate.map(toTypeName).filter(Boolean);
          }

          if (
            serviceTypesArrCandidate &&
            Array.isArray(serviceTypesArrCandidate.TypeService)
          ) {
            return serviceTypesArrCandidate.TypeService
              .map(toTypeName)
              .filter(Boolean);
          }

          if (
            serviceTypesArrCandidate &&
            Array.isArray(serviceTypesArrCandidate.serviceTypes)
          ) {
            return serviceTypesArrCandidate.serviceTypes
              .map(toTypeName)
              .filter(Boolean);
          }

          return [];
        })();

        const quotedTotal =
          selectedLead?.quotedprice ??
          selectedLead?.quotedPrice ??
          selectedLead?.QuotedPrice ??
          selectedLead?.QuotedValue ??
          0;

        const safeTotal = Number(quotedTotal) || 0;

        const isUSA = String(currency || "").trim() === "$";
        // Format commas while typing (USA: 3-3-3..., India: 12,34,56...).
        const onInputFormat = isUSA
          ? "let v=(this.value||'').toString().replace(/[^0-9]/g,''); this.value=v.replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',');"
          : "let v=(this.value||'').toString().replace(/[^0-9]/g,''); if(v.length<=3){this.value=v;return;} let last3=v.slice(-3); let other=v.slice(0,-3); other=other.replace(/\\B(?=(\\d{2})+(?!\\d))/g, ','); this.value=other+','+last3;";

        const priceHeader = currency ? `Price (${currency})` : "Price";

        const hasHardwareService = serviceTypes.some(
          (st) => String(st || "").trim().toLowerCase() === "hardware"
        );
        const safeServiceTypes = serviceTypes.map((serviceType) =>
          String(serviceType).replace(/</g, "&lt;")
        );

        tableHtml = `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 520px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Finance Summary</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Service types</th><th style="${cellStyle} text-align: right;">${priceHeader}</th></tr></thead><tbody>${safeServiceTypes
          .map((serviceType, idx) => {
            // Leave input blank so user can enter price per service type.
            return `<tr style="background-color: #fff;"><td style="${cellStyle}">${serviceType}</td><td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="servicePrice_${idx}" value="" onkeydown="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeypress="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeyup="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onbeforeinput="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();" oninput="${onInputFormat}; this.setAttribute('value', this.value);" /></td></tr>`;
          })
          .join("")}<tr style="background-color: #bfdbfe; font-weight: bold;"><td style="${cellStyle}">Total quoted price</td><td style="${cellStyle} text-align: right;">${USAComma(Number(safeTotal).toFixed(2))}</td></tr></tbody></table></div></div>`;

        if (hasHardwareService) {
          tableHtml += `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 520px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Hardware Details</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Part name</th><th style="${cellStyle} text-align: right;">Part qty</th></tr></thead><tbody><tr style="background-color: #fff;"><td style="${cellStyle}"><input type="text" style="width: 100%; border: none; outline: none; text-align: left; font-size: 12px;" name="hardwarePartName_0" value="" onkeydown="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeypress="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeyup="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onbeforeinput="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();" oninput="this.setAttribute('value', this.value);" /></td><td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="hardwarePartQty_0" value="" onkeydown="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeypress="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeyup="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onbeforeinput="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();" oninput="this.value=(this.value||'').toString().replace(/[^0-9]/g,''); this.setAttribute('value', this.value);" /></td></tr></tbody></table><div style="display:flex; justify-content:flex-end; gap:8px; margin-top:8px;"><button type="button" style="padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;" onclick="(function(btn){var table=btn.closest('div').previousElementSibling; if(!table) return; var tbody=table.querySelector('tbody'); if(!tbody) return; var rowCount=tbody.querySelectorAll('tr').length; var uid=Date.now()+''+Math.floor(Math.random()*1000); var tr=document.createElement('tr'); tr.style.backgroundColor='#fff'; tr.innerHTML='<td style=&quot;${cellStyle}&quot;><input type=&quot;text&quot; style=&quot;width:100%; border:none; outline:none; text-align:left; font-size:12px;&quot; name=&quot;hardwarePartName_'+uid+'&quot; value=&quot;&quot; onkeydown=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeypress=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeyup=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onbeforeinput=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onmousedown=&quot;event.stopPropagation();&quot; onclick=&quot;event.stopPropagation();&quot; oninput=&quot;this.setAttribute(\\'value\\', this.value);&quot; /></td><td style=&quot;${cellStyle} text-align:right;&quot;><input type=&quot;text&quot; inputmode=&quot;numeric&quot; style=&quot;width:100%; border:none; outline:none; text-align:right; font-size:12px;&quot; name=&quot;hardwarePartQty_'+uid+'&quot; value=&quot;&quot; onkeydown=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeypress=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeyup=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onbeforeinput=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onmousedown=&quot;event.stopPropagation();&quot; onclick=&quot;event.stopPropagation();&quot; oninput=&quot;this.value=(this.value||\\'\\').toString().replace(/[^0-9]/g,\\'\\'); this.setAttribute(\\'value\\', this.value);&quot; /></td>'; tbody.appendChild(tr);})(this)">+</button><button type="button" style="padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;" onclick="(function(btn){var table=btn.closest('div').previousElementSibling; if(!table) return; var tbody=table.querySelector('tbody'); if(!tbody) return; var rows=tbody.querySelectorAll('tr'); if(rows.length<=1) return; tbody.removeChild(rows[rows.length-1]);})(this)">-</button></div></div></div>`;
        }

        return `<!-- AUTO_SUMMARY_TABLES -->${tableHtml}`;
      }

      // Use quoted prices from P&L table when provided, otherwise fallback to calculating from costs
      let serviceTotals = [];
      let grandTotal = 0;

      if (tableServiceTotalsProp && Object.keys(tableServiceTotalsProp).length > 0) {
        // Use quoted prices from P&L table (tableServiceTotalsProp)
        serviceTotals = Object.entries(tableServiceTotalsProp).map(
          ([serviceType, quotedPrice]) => ({
            serviceType,
            quotedPrice: Number(quotedPrice) || 0,
          })
        );
        grandTotal = serviceTotals.reduce(
          (sum, item) => sum + item.quotedPrice,
          0
        );
      } else {
        // Fallback: Calculate from costs if tableServiceTotalsProp is not available
        serviceTotals = Object.entries(groupedData).map(
          ([serviceType, items]) => {
            const totalCost = items.reduce(
              (sum, item) => sum + (item.grandTotal || 0),
              0
            );
            return { serviceType, quotedPrice: totalCost };
          }
        );
        grandTotal = serviceTotals.reduce(
          (sum, item) => sum + item.quotedPrice,
          0
        );
      }

      const cellStyle =
        "border: 2px solid #000; padding: 10px 12px; font-size: 12px; line-height: 1.2;";
      const rows = serviceTotals
        .map(
          ({ serviceType, quotedPrice }) => `
      <tr>
        <td style="${cellStyle} text-align: left;">${serviceType}</td>
        <td style="${cellStyle} text-align: right;">${USAComma(
            quotedPrice
          )}</td>
      </tr>
    `
        )
        .join("");

      // ---- Updated Hardware Section ----
      let hardwareSection = "";
      if (hardwareparts?.length > 0) {
        // Consolidated part list rule:
        // when the same part appears for multiple roles (hardware manager / operations),
        // keep the maximum quantity for that part instead of summing.
        const consolidatedPartQuantities = {};
        hardwareparts.forEach((item) => {
          const part = String(item?.assemblepartdescription || "").trim() || " ";
          const quantity = Number(item?.quantity) || 0;
          const existing = consolidatedPartQuantities[part] || 0;
          consolidatedPartQuantities[part] = Math.max(existing, quantity);
        });

        const tableRows = Object.entries(consolidatedPartQuantities)
          .map(
            ([part, totalQuantity]) => `
        <tr>
          <td style="${cellStyle} text-align: left;">${part}</td>
          <td style="${cellStyle} text-align: right;">${totalQuantity}</td>
        </tr>`
          )
          .join("");

        hardwareSection = `
      <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin: 12px 0 6px 0; font-weight: 700; font-size: 16px;">Required Hardware</div>

      <table style="width: 100%; max-width: 650px; margin: 0 auto 10px auto; border-collapse: collapse; table-layout: fixed; border: 2px solid #000;">
          <thead>
            <tr style="background-color: #e7ebfb; font-weight: 700;">
              <th style="${cellStyle} width: 70%; text-align: left;">Part</th>
              <th style="${cellStyle} width: 30%; text-align: right;">Quantity</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
    `;
      }

      // ---- Final HTML ----
      // NOTE: We wrap the whole block with an identifying comment so we can safely
      // detect and avoid inserting duplicates later.
      return `
    <!-- AUTO_SUMMARY_TABLES -->
    <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin: 12px 0 6px 0; font-weight: 700; font-size: 16px;">Services</div>

    <table style="width: 100%; max-width: 650px; margin: 0 auto 10px auto; border-collapse: collapse; table-layout: fixed; border: 2px solid #000;">
      <thead>
        <tr style="background-color: #e7ebfb; font-weight: 700;">
          <th style="${cellStyle} width: 70%; text-align: left;">Service Type</th>
          <th style="${cellStyle} width: 30%; text-align: right;">Quoted Price (${currency})</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
        <tr style="background-color: #bfdbfe; font-weight: 700;">
          <td style="${cellStyle} text-align: left;">Total</td>
          <td style="${cellStyle} text-align: right;">${USAComma(
        grandTotal
      )}</td>
        </tr>
      </tbody>
    </table>

    ${hardwareSection}
  `;
    },
    [hardwareparts, USAComma, currency, tableServiceTotalsProp, profiles, selectedLead]
  );

  const serviceTableHTML = useMemo(
    () => generateServiceTableHTML(groupedData),
    [groupedData, generateServiceTableHTML]
  );

  // Update content when serviceTableHTML changes (e.g., when quoted price changes)
  useEffect(() => {
    if (!content || !serviceTableHTML) return;

    let updatedContent = content;

    if (content.includes("<!-- SUMMARY_TABLES -->")) {
      // Case 1: New templates that contain the explicit placeholder
      const placeholderIndex = content.indexOf("<!-- SUMMARY_TABLES -->");
      if (placeholderIndex !== -1) {
        const afterPlaceholder = content.substring(placeholderIndex);
        const tableEndIndex = afterPlaceholder.indexOf("</table>");

        if (tableEndIndex !== -1) {
          const beforePlaceholder = content.substring(0, placeholderIndex);
          const afterTable = afterPlaceholder.substring(
            tableEndIndex + "</table>".length
          );
          updatedContent = beforePlaceholder + serviceTableHTML + afterTable;
        } else {
          // No closing </table> found, just replace the placeholder token
          updatedContent = content.replace(
            "<!-- SUMMARY_TABLES -->",
            serviceTableHTML
          );
        }
      }
    } else if (!content.includes("<!-- AUTO_SUMMARY_TABLES -->")) {
      // Case 2: Older templates on other servers that don't have {{Summary Tables}}
      // Append the auto-generated block once at the end of the template body.
      updatedContent = content + serviceTableHTML;
    }

    // Only update if content actually changed to avoid infinite loops
    if (updatedContent !== content) {
      setContent(updatedContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceTableHTML, tableServiceTotalsProp]);

  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <div>
        <div className="fixed w-full inset-0 bg-black/50 flex items-center justify-center z-[1300]">
          <div className="min-w-[60%] max-h-[98%] max-w-[70%] bg-white shadow-lg rounded-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-bold">Quotation</h2>


              <button
                onClick={() => {
                  setIsEdit(false);
                  setShowEditPreview(false);
                  setShowQuoteModal(false);
                }}
                className="text-gray-500 hover:text-black"
              >
                Close
              </button>
            </div>
            <div className="w-full flex justify-between">
              <div className="flex gap-2">

                <div
                  className="relative inline-block gap-2 justify-center align-middle items-center"
                  ref={groupdownRef}
                >
                  <label
                    htmlFor="selectedStatus"
                    className="block text-sm font-semibold text-gray-700"
                  >
                    Template
                  </label>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsTemplateOpen(!isTemplateOpen);
                    }}
                    className="w-24 relative outline-none date-picker-placeholder flex justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                  >
                    <span
                      onClick={() => setAssignedGroup()}
                      className="truncate min-w-0 flex-1 text-left"
                    >
                      {selectedTemplate ? selectedTemplate : "All"}
                    </span>
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>
                  {isTemplateOpen && (
                    <div className="absolute left-0 top-full w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                      <div
                        className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === "All" ? "bg-gray-300" : ""
                          }`}
                        onClick={() => {
                          setIsTemplateOpen(false);
                        }}
                      >
                        <label>All</label>
                      </div>

                      {template.map((temp) => (
                        <div
                          key={temp.id}
                          className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === temp.newGroupName
                            ? "bg-gray-300"
                            : ""
                            }`}
                          onClick={() => {
                            setIsTemplateOpen(false);
                            loadTemplate(temp.templatedataUrl);
                            setselectedTemplate(temp.templatename);
                            setTemplateid(temp._id);
                            setsendid("");
                          }}
                        >
                          <label>{temp.templatename}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div
                  ref={versionRef}
                  className="relative flex flex-col justify-center align-middle items-center"
                >
                  <label
                    htmlFor="selectedStatus"
                    className="block text-sm font-semibold text-gray-700"
                  >
                    Version History
                  </label>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowVersionHistoryHint(false);
                      setisHistoryOpen(!isHistoryOpen);
                    }}
                    className={`w-24 relative outline-none date-picker-placeholder flex justify-start rounded-md p-2 pr-7 text-xs transition-all duration-300 ${showVersionHistoryHint
                      ? "border border-emerald-500 shadow-[0_0_0_3px_rgba(16,185,129,0.18)] animate-pulse"
                      : "border border-[#e0e7ff]"
                      }`}
                  >
                    <span
                      onClick={() => setAssignedGroup()}
                      className="truncate min-w-0 flex-1 text-left"
                    >
                      All
                    </span>
                    {showVersionHistoryHint && (
                      <span className="pointer-events-none absolute right-8 top-1/2 z-10 flex h-2.5 w-2.5 -translate-y-1/2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" />
                        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
                      </span>
                    )}
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>
                  {isHistoryOpen && (
                    <div className="absolute left-0 top-full w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                      <div
                        className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === "All" ? "bg-gray-300" : ""
                          }`}
                        onClick={() => {
                          setIsTemplateOpen(false);
                        }}
                      >
                        <label>All</label>
                      </div>

                      {(() => {
                        // Filter only GeneratedQuote type quotations
                        const generatedQuotes = quotation.filter(q => q.type === "GeneratedQuote");
                        // Sort quotations by createdAt in ascending order (oldest first)
                        const sortedQuotations = [...generatedQuotes].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                        
                        return sortedQuotations.length > 0 ? (
                          sortedQuotations.map((quot, index) => (
                            <div
                              key={quot._id}
                              className="flex justify-between align-middle items-center p-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => {
                                setIsTemplateOpen(false);
                                if (quot.type === "GeneratedQuote") {
                                  setFiles(quot.generateddatafilepath);
                                  setsendid(quot.leadid);
                                  setdownloadid(quot._id);
                                  seteditContent(quot.templatedata);
                                  setTemplateid(quot.templateid);
                                  setsetMailQuotation(quot)
                                } else {
                                  setFiles();
                                  setContent(quot.templatedata); // Use setContent
                                  setsendid(null);
                                  setsetMailQuotation(quot)
                                }
                                setisHistoryOpen(!isHistoryOpen);
                                setselectedTemplate("");
                              }}
                            >
                              <div className="flex items-center">
                                <span>{getQuotationIdentifier(quot)}</span>
                                <span>_v{index + 1}</span>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="p-2 text-center text-gray-500">
                            No quotation
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex gap-2 justify-end align-bottom items-end">
                {showEditPreview ? (
                  <>
                <button
                      onClick={() => setShowEditPreview(false)}
                      className="p-1.5 text-sm rounded-md bg-gray-500 text-white inline-block"
                    >
                      Back to Edit
                    </button>
                    <button
                      onClick={handleGenerateFromPreview}
                      className="p-1.5 text-sm rounded-md bg-[#e32278] text-white inline-block"
                >
                  Generate
                </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={IsEdit ? handleSaveEdit : handleGenerate}
                      className="p-1.5 text-sm rounded-md bg-[#e32278] text-white inline-block"
                    >
                      {IsEdit ? "Save" : "Generate"}
                    </button>
                    {files && !IsEdit && (
                  <button
                    onClick={handleedit}
                        className="px-3.5 py-1.5 text-sm rounded-md bg-[#e32278] text-white inline-block"
                  >
                    Edit
                  </button>
                )}
                <button
                  disabled={!files}
                  onClick={() => handleDownload()}
                  className={`${!files
                    ? "cursor-not-allowed bg-gray-400"
                    : "cursor-pointer bg-[#e32278]"
                        } p-1.5 text-sm rounded-md text-white inline-block`}
                >
                  Download
                </button>
                <button
                  disabled={!files}
                  onClick={handleSend}
                  className={`${!files
                    ? "cursor-not-allowed bg-gray-400"
                    : "cursor-pointer bg-[#e32278]"
                        } p-1.5 text-sm rounded-md text-white inline-block`}
                >
                  Send Email
                </button>
                  </>
                )}
              </div>
            </div>
            <div className="w-full min-h-[5rem] max-h-[24rem] overflow-y-scroll p-2 border mt-2">
              <input
                ref={imageUploadInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageFileSelected}
                style={{ display: "none" }}
              />
              {showEditPreview ? (
                <div className="preview w-full p-4 bg-white">
                  <div className="text-sm font-semibold text-gray-600 mb-2">Quotation Preview (Edited)</div>
                  <div
                    className="border rounded p-4 min-h-[20rem] bg-white"
                    dangerouslySetInnerHTML={{ __html: editedTemplate || content || "" }}
                  />
                </div>
              ) : sendid ? (
                <FileViewer files={files} />
              ) : (
                <div className="preview w-full shadow-[inset_0_0_10px_rgba(0,0,0,0.3)]">
                  {content ? (
                    <div className="flex h-[20rem]">
                      <div className="w-full">
                        <JoditEditor
                          ref={editor}
                          value={content}
                          config={config}
                          onChange={(newContent) => {
                            setContent(newContent);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>No Template</div>
                  )}

                  {content && // Use content instead of value
                    (showfile?.[0]?.message ===
                      "No files available for the given Lead ID" ||
                      showfile?.files?.length === 0 ? (
                      <div>No Attachament</div>
                    ) : (
                      <FilesViewer showfile={showfile} />
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuotationWizard;
